export const SIGN_ON_TYPES = {
  MANUALLY_CREATED_SIGN_ON: 'MANUAL_SIGN_ON',
  GATE_ACCESS_CREATED_SIGN_ON: 'GATE_ACCESS_CREATED_SIGN_ON',
  FORM_CREATED_SIGN_ON: 'FORM_CREATED_SIGN_ON',
  APP_AUTO_SIGN_ON_OFF: 'APP_AUTO_SIGN_ON_OFF',
}
